import React from 'react';
import { useTranslation } from 'react-i18next';
import * as PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import Typography from '@material-ui/core/Typography';
import { Grid, Box } from '@material-ui/core';
import { ReactComponent as LogoSVG } from './assets/Logo.svg';
import { useStyles } from './styles';
import { LanguageItem } from '../../shared/layout/LanguageItem';

const UnauthorizedLayout = (props: any) => {
  const { title, subtitle, children, subtitleLink } = props;
  const [t, i18n] = useTranslation();
  const classes = useStyles();

  return (
    <main className={classes.root}>
      {title && (
        <Helmet>
          <title>
            {title} | {process.env.REACT_APP_NAME}
          </title>
        </Helmet>
      )}
      <Grid container className={classes.maintWrapper}>
        <Grid item xs={12} sm={7} className={classes.contentWrapper}>
          <div className={classes.table}>
            <div className={classes.tableRow}>
              <Box
                className={classes.tableCellHeader}
                px={3}
                pt={{ xs: 3, md: 7 }}
                pb={{ xs: 9, md: 7 }}
              >
                <a href={process.env.REACT_APP_LANDING_URL}>
                  <LogoSVG className={classes.logo} />
                </a>
                <span className={classes.switcherWrapper}>
                  {['en', 'de']
                    .map((lang) => (
                      <LanguageItem
                        key={`${lang}-key`}
                        language={lang}
                        i18n={i18n}
                      />
                    ))
                    // @ts-ignore next
                    .reduce((prev, curr) => [prev, ' | ', curr])}
                </span>
              </Box>
            </div>
            <div className={classes.tableRow}>
              <div className={classes.tableCellBody}>
                {title && (
                  <Box
                    component={Typography}
                    color="info"
                    px={3}
                    pt={1}
                    pb={1}
                    // @ts-ignore next
                    variant="h2"
                  >
                    {title}
                  </Box>
                )}
                {subtitle && (
                  <Box
                    component={Typography}
                    px={3}
                    py={1}
                    // @ts-ignore next
                    variant="body1"
                  >
                    {subtitle}
                  </Box>
                )}
                {subtitle && subtitleLink && (
                  <Box
                    component={Typography}
                    px={3}
                    py={1}
                    // @ts-ignore next
                    variant="body1"
                  >
                    <a href={subtitleLink}>{subtitle}</a>
                  </Box>
                )}
                {children}
              </div>
            </div>
            <div className={classes.tableRow}>
              <Box
                className={classes.tableCellFooter}
                component={Typography}
                px={3}
                py={{ xs: 5, md: 7 }}
                // @ts-ignore next
                variant="body2"
              >
                {t('Shared.copyright')}
              </Box>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={5} className={classes.illustrationSection}>
          <Box className={classes.illustrationSection} />
        </Grid>
      </Grid>
    </main>
  );
};

UnauthorizedLayout.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  subtitleLink: PropTypes.string,
  children: PropTypes.node,
};

UnauthorizedLayout.defaultProps = {
  title: '',
  subtitle: '',
  subtitleLink: null,
  children: null,
};

export default UnauthorizedLayout;
